// extracted by mini-css-extract-plugin
module.exports = {"amountCell":"amountCell__WL809","split":"split__fkm1C","amount":"amount__gjreD","amountTotal":"amountTotal__oROQN","total":"total__GN90J"};